import { createActionTypeModel } from "../../../../store/global/action-model";


export const BOOKING_TOURS = createActionTypeModel('BOOKING_TOURS');
